import { IHospitalProps } from '@/entities/Hospital'

export const hasHospitalSubmissionDocUpload = (hospital?: IHospitalProps | null): boolean => {
  return !!hospital?.data
}

export const shouldDeleteHospitalSubmissionDoc = (hospital?: IHospitalProps | null): boolean => {
  return !!(hospital?.submissionDoc?.file && !hasHospitalSubmissionDocUpload(hospital) && Array.isArray(hospital?.keeps) && hospital.keeps.length === 0)
}

export const isHospitalSubmissionDocChanged = (hospital?: IHospitalProps | null): boolean => {
  return hasHospitalSubmissionDocUpload(hospital) || shouldDeleteHospitalSubmissionDoc(hospital)
}
